import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import {
  // AppBar,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Button,
  // Container,
  Divider,
  // Drawer,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  Menu,
  MenuItem,
  Paper,
  Stack,
  Tab,
  Tabs,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
  useTheme,
  // useMediaQuery,
  // useScrollTrigger,
  // useTheme,
} from '@mui/material';
import { AppBar, Toolbar as MuiToolbar } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
// import TabPanel from '@mui/lab/TabPanel';

const Item = styled(Paper)(({ theme, bg }) => ({
  backgroundColor: bg || theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const ScreenContainer = ({
  styles,
  children,
  sx = {},
  title,
  buttons,
  showSearchBar = false,
  searchValue,
  setSearchValue,
  handleSearch,
  searchIconStatus,
  toggleButtons = [],
  footer,
  tabs,
  stickyZIndex,
  // drawerOptions,
  isProgress,
  appBarSX = { top: { xs: 58, sm: 64 } },
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [navIndex, setNavIndex] = useState(0);
  // const drawerWidth = 240;
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (event, newValue) => {
    setNavIndex(newValue);
  };

  // const theme = useTheme();
  // const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

  const Header = () => {
    if (!title) return null;
    return (
      <Box sx={{ p: 0, m: 0 }}>
        <Typography
          variant={
            styles?.header?.titleVariant ? styles.header.titleVariant : 'h6'
          }
          sx={styles?.header?.title ? styles?.header?.title : null}
        >
          {title}
        </Typography>
      </Box>
    );
  };

  const ToolbarItem = ({ el }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClickMenu = (event) => {
      console.log(event.currentTarget);

      setAnchorEl(event.currentTarget);
    };
    if (el?.type === 'divider') {
      return (
        <Divider
          orientation={el?.orientation || 'vertical'}
          flexItem={el?.flexItem || false}
        />
      );
    }
    if (el.type === 'component') {
      return (
        <Tooltip title={el?.label} placement='top-start'>
          <Item>{el.component}</Item>
        </Tooltip>
      );
    }
    if (el.type === 'icon') {
      return (
        // <Tooltip title={el?.label} placement='top-start'>
        <Item bg={el?.bg}>
          <IconButton
            onClick={() => {
              if (el.link) {
                navigate(el.link);
              } else if (typeof el?.onClick === 'function') {
                el.onClick();
              } else {
                return false;
              }
            }}
            aria-label={el?.arialabel || 'settings'}
            title={el?.title}
            size={el?.size || 'small'}
            color={el?.color || 'inherit'}
          >
            {el.icon}
          </IconButton>
        </Item>
        // </Tooltip>
      );
    }
    if (el.type === 'text') {
      return (
        <Tooltip title={el?.label} placement='top-start'>
          <Button
            color={el?.color || 'primary'}
            variant={el?.variant || 'text'}
            onClick={() => {
              if (el.link) {
                navigate(el.link);
              } else if (typeof el?.onClick === 'function') {
                el.onClick();
              } else {
                return false;
              }
            }}
          >
            {el.label || el.title}
          </Button>
        </Tooltip>
      );
    }
    if (el.type === 'menu' && Array.isArray(el.items)) {
      return (
        <div>
          <Tooltip title={el?.label} placement='top-start'>
            <Item bg={el?.bg}>
              <IconButton
                id='menu-button'
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup='true'
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClickMenu}
                aria-label={el?.arialabel || 'settings'}
                size={el?.size || 'small'}
                color={el?.color || 'inherit'}
              >
                {el.icon}
              </IconButton>
            </Item>
          </Tooltip>
          <Menu
            id='basic-menu'
            anchorEl={anchorEl}
            open={open}
            onClose={() => el.onClose()}
            MenuListProps={{
              'aria-labelledby': 'menu-button',
            }}
          >
            {el.items.map((item, index) => (
              <MenuItem
                key={item?.id || item?._id || index}
                onClick={() => el.onClose(item)}
              >
                {item.title || item.label || item.name}
              </MenuItem>
            ))}
          </Menu>
        </div>
      );
    }
    return null;
  };

  const GridMenu = ({ position }) => {
    const items = buttons.filter((item) => item?.position === position);
    if (items.length === 0) {
      return <Stack></Stack>;
    }

    let defaultXs = Math.floor(buttons.length / 12);
    if (defaultXs < 1) defaultXs = 1;
    if (defaultXs > 12) defaultXs = 12;

    return (
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        spacing={1}
        sx={{ p: 0, m: 0 }}
      >
        {items.map((el, index) => (
          <Grid item xs={el?.xs || true} key={index}>
            <ToolbarItem el={el} />
          </Grid>
        ))}
      </Stack>
    );
  };

  const ToggleMenu = ({ position }) => {
    const items = toggleButtons.filter((item) => item?.position === position);
    if (items.length === 0) {
      return null;
    }

    const ToggleButtonIcon = ({ button }) => {
      return (
        <ToggleButton
          value={button?.value}
          aria-label={button?.ariaLabel}
          onClick={button?.onClick}
        >
          {button?.icon}
        </ToggleButton>
      );
    };

    const ToggleButtonMenu = ({ button }) => {
      const [anchorEl, setAnchorEl] = React.useState(null);
      const open = Boolean(anchorEl);

      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };

      return (
        <>
          <ToggleButton
            onClick={handleClick}
            value={button?.value}
            aria-label={button?.ariaLabel}
          >
            {button?.icon}
          </ToggleButton>
          <Menu
            id='basic-menu'
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            {button?.items?.map((item, index) => (
              <MenuItem
                key={item?.id || item?._id || index}
                onClick={() => {
                  button.onClose(item);
                  setAnchorEl(null);
                }}
              >
                {item.title || item.label || item.name}
              </MenuItem>
            ))}
          </Menu>
        </>
      );
    };

    return (
      <ToggleButtonGroup
        size='small'
        value={'left'}
        exclusive
        onChange={() => {}}
        aria-label='text alignment'
        sx={{ p: 0, m: 0 }}
      >
        {items.map((btn, index) => {
          if (btn?.type === 'Divider') {
            return (
              <Divider
                key={index}
                orientation={btn?.orientation || 'vertical'}
                flexItem={btn?.flexItem || false}
              />
            );
          } else if (btn?.type === 'ToggleButton') {
            if (Array.isArray(btn?.items)) {
              return <ToggleButtonMenu button={btn} key={index} />;
            } else {
              return <ToggleButtonIcon button={btn} key={index} />;
            }
          } else {
            return null;
          }
        })}
      </ToggleButtonGroup>
    );
  };

  const Toolbar = ({ position }) => {
    if (Array.isArray(buttons)) {
      return <GridMenu position={position} />;
    }

    if (Array.isArray(toggleButtons)) {
      return <ToggleMenu position={position} />;
    }

    return null;
  };

  const TabsBar = () => {
    if (!Array.isArray(tabs?.buttons) || tabs.buttons.length === 0) return null;

    return (
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          variant='scrollable'
          scrollButtons='auto'
          allowScrollButtonsMobile
          sx={{
            mb: 2,
            '& .MuiTabs-flexContainer': {
              flexWrap: { xs: 'wrap', sm: 'nowrap' }, // 2 ряда на мобилке
              gap: 0.5,
            },
            minHeight: 48, // Фикс высоты
          }}
          value={navIndex}
          onChange={handleChange}
          aria-label='basic tabs'
        >
          {tabs.buttons.map((el, index) => (
            <Tab
              icon={el?.icon}
              // label={isMobile ? false : el?.label} // Только иконка на мобилке
              key={index}
              id={`tab-${index}`}
              aria-controls={`tabpanel-${index}`}
              sx={{
                minWidth: 0,
                maxWidth: { xs: 56, sm: 'auto' }, // Фикс ширина иконки на xs
                // '& .MuiTab-wrapper': {
                //   flexDirection: 'row', // Всегда row
                //   gap: 0.5,
                // },
              }}
            />
            // <Tab
            //   icon={el?.icon}

            //   key={index}
            //   label={el?.label}
            //   id={`tab-${index}`}
            //   aria-controls={`tabpanel-${index}`}
            //   sx={{
            //     minWidth: 0, // Сжимает таб
            //     flex: { xs: 0, sm: 1 }, // Только иконка на xs
            //     '& .MuiTab-wrapper': {
            //       // Иконка+label контейнер
            //       flexDirection: { xs: 'column', sm: 'row' }, // Вертикально на мобилке
            //       gap: { xs: 0, sm: 0.5 },
            //     },
            //     '& .MuiTab-labelIcon': {
            //       // Label после иконки
            //       display: { xs: 'none', sm: 'block' }, // Скрываем label на мобилке
            //       ml: 0,
            //     },
            //   }}
            // />
          ))}
        </Tabs>
      </Box>
    );
  };

  const TabPanelContent = () => {
    if (!Array.isArray(tabs?.panels)) return null;

    function TabPanel(props) {
      const { children, value, index, ...other } = props;

      return (
        <div
          role='tabpanel'
          hidden={value !== index}
          id={`full-width-tabpanel-${index}`}
          aria-labelledby={`full-width-tab-${index}`}
          {...other}
        >
          {value === index && <Box>{children}</Box>}
        </div>
      );
    }

    return (
      <>
        {tabs.panels
          .filter((item) => item?.visible)
          .map((panel, index) => (
            <TabPanel value={navIndex} index={index} key={index}>
              {panel?.content}
            </TabPanel>
          ))}
      </>
    );
  };

  const BottomBar = () => {
    if (
      !Array.isArray(footer?.buttons) ||
      (Array.isArray(footer?.buttons) && footer.buttons.length === 0)
    ) {
      return null;
    }
    return (
      <Paper
        sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}
        elevation={3}
      >
        <BottomNavigation
          showLabels={footer?.showLabels || false}
          value={navIndex}
          onChange={(event, newValue) => {
            setNavIndex(newValue);
          }}
        >
          {footer.buttons.map((el, index) => (
            <BottomNavigationAction
              key={index}
              label={el.label}
              icon={<el.icon />}
            />
          ))}
        </BottomNavigation>
      </Paper>
    );
  };

  const RenderPage = ({ footer, navIndex }) => {
    if (
      Array.isArray(footer?.screens) &&
      footer.screens.length > 0 &&
      footer.screens[navIndex]
    ) {
      const { component } = footer.screens[navIndex];

      // Проверяем, что component является функцией или классом
      if (typeof component === 'function') {
        return React.createElement(component); // Используем createElement для создания элемента
      }
    }

    return null; // Возвращаем null, если не удалось отобразить компонент
  };

  // function ElevationScroll(props) {
  //   const { children, window } = props;
  //   // // Note that you normally won't need to set the window ref as useScrollTrigger
  //   // // will default to window.
  //   // // This is only being set here because the demo is in an iframe.
  //   const trigger = useScrollTrigger({
  //     disableHysteresis: true,
  //     threshold: 0,
  //     target: undefined,
  //   });

  //   return children
  //     ? React.cloneElement(children, {
  //         // elevation: 4,
  //         elevation: trigger ? 4 : 0,
  //       })
  //     : null;
  // }

  // console.log('drawerOptions', drawerOptions);

  const effectiveZIndex =
    stickyZIndex !== undefined ? stickyZIndex : theme.zIndex.appBar + 1;

  return (
    <>
      <Box
        sx={{
          p: 0,
          m: 0,
          minHeight: '100vh',
          maxWidth: '720px',
          ...sx,
        }}
      >
        <AppBar
          position='sticky'
          color='default' // или "inherit", "primary"
          elevation={0}
          sx={{
            // top: { xs: 58, sm: 64 },
            zIndex: effectiveZIndex,
            ...appBarSX,
          }}
        >
          <MuiToolbar
            variant='dense' // компактнее
            disableGutters
            sx={{
              minHeight: { xs: 48, sm: 56 },
              justifyContent: 'space-between',
              px: 2,
            }}
          >
            <Toolbar position='left' />
            <Header />
            <Toolbar position='right' />
            {/* </Stack> */}
          </MuiToolbar>
          {showSearchBar && (
            <TextField
              id='search-field'
              size='small'
              fullWidth
              variant='filled'
              placeholder='Поиск...'
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              // ← Реакция на Enter
              onKeyDown={(e) => {
                console.log(e);
                if (e.key === 'Enter' || e.keyCode === 13) {
                  e.preventDefault(); // предотвращаем перенос строки (особенно важно в multiline)
                  handleSearch();
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    {searchIconStatus === 'clear' ? (
                      <ClearIcon
                        sx={{ cursor: 'pointer', color: 'action.active' }}
                        onClick={() => handleSearch(false)}
                      />
                    ) : (
                      <SearchIcon
                        sx={{ cursor: 'pointer', color: 'action.active' }}
                        onClick={handleSearch} // ← клик по иконке
                      />
                    )}
                  </InputAdornment>
                ),

                // Очень помогает на мобильных устройствах — показывает кнопку "ОК"/"Найти"
                inputProps: {
                  autoComplete: 'off',
                  // можно попробовать: enterKeyHint: 'search'  (работает в большинстве современных браузеров)
                },
              }}
            />
          )}
        </AppBar>
        {isProgress && <LinearProgress />}
        {tabs && tabs.position === 'top' && (
          <>
            <TabsBar /> <TabPanelContent />
          </>
        )}

        {children}
        {tabs && tabs.position === 'bottom' && (
          <>
            <TabsBar /> <TabPanelContent />
          </>
        )}
        <RenderPage footer={footer} navIndex={navIndex} />
        <BottomBar />
        {/* </Box> */}
      </Box>
    </>
  );
};

export default ScreenContainer;
